import { TFunction } from 'i18next'
import { z } from 'zod'

import { UpdateAccountFromTemplateFormSchema } from '../types'
import { getAccountFromTemplateFormShape } from './getAccountFromTemplateFormShape'

export const getUpdateAccountFromTemplateFormSchema = (t: TFunction): UpdateAccountFromTemplateFormSchema =>
  z.object(getAccountFromTemplateFormShape(t))
